const lotteryRoutes = [
  {
    path: '/lottery/home',
    name: 'lottery-home',
    component: () => import('@/views/lottery/lottery-home')
  },
  {
    path: '/lottery/coupon',
    name: 'lottery-coupon',
    component: () => import('@/views/lottery/lottery-coupon')
  }
]

export default lotteryRoutes
